// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PMailOutlinedSvg from "@fishx/icons-svg/es/asn/PMailOutlined";
import FishxIcon from '../components/FishxIcon';

var PMailOutlined = function PMailOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PMailOutlinedSvg
  }));
};

PMailOutlined.displayName = 'PMailOutlined';
export default React.forwardRef(PMailOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PMailOutlined.js
// module id = 3504
// module chunks = 0